var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJeep({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_407",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29013",
    "data-name": "Group 29013",
    transform: "translate(-3820 4996)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3820, -4996)",
    filter: "url(#Ellipse_407)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_407-2",
    "data-name": "Ellipse 407",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-jeep",
    transform: "translate(3837 -4985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50593",
    "data-name": "Path 50593",
    d: "M10.213,14v9.055c0,1.489-.57,4.562-5.106,4.562S0,24.757,0,23.123V21.66H3.166V23.1A1.758,1.758,0,0,0,5,24.936a1.729,1.729,0,0,0,1.932-1.813V14Z",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50594",
    "data-name": "Path 50594",
    d: "M17.388,26.261c-.981,0-1.536-.766-1.536-2.155h5.659c0-4.351-2.321-5.106-4.255-5.106C13.774,19,13,21.638,13,23.9a4.257,4.257,0,0,0,4.255,4.46c2.52,0,4.219-1.659,4.219-2.907H18.7A1.4,1.4,0,0,1,17.388,26.261Zm-.163-5.371a1.5,1.5,0,0,1,1.506,1.656H15.852C15.852,21.638,16.209,20.89,17.226,20.89Z",
    transform: "translate(-1.936 -0.745)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50595",
    "data-name": "Path 50595",
    d: "M28.388,26.261c-.981,0-1.536-.766-1.536-2.155h5.659c0-4.351-2.321-5.106-4.255-5.106C24.774,19,24,21.638,24,23.9a4.257,4.257,0,0,0,4.255,4.46c2.52,0,4.219-1.659,4.219-2.907H29.7A1.4,1.4,0,0,1,28.388,26.261Zm-.163-5.371a1.5,1.5,0,0,1,1.506,1.656H26.852C26.852,21.638,27.209,20.89,28.226,20.89Z",
    transform: "translate(-3.574 -0.745)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50596",
    "data-name": "Path 50596",
    d: "M41.286,19A3.046,3.046,0,0,0,38.4,20.523V19H35V31.766h3.4V27.511a3.332,3.332,0,0,0,2.917,1.208c2.466,0,3.891-2.122,3.891-5.02C45.213,19.947,42.82,19,41.286,19Zm-.928,7.557c-1.5,0-1.989-.949-1.954-2.753s.849-2.544,1.81-2.544c1.571,0,1.861,1.2,1.861,2.438S41.855,26.557,40.358,26.557Z",
    transform: "translate(-5.213 -0.745)",
    fill: "#455a64"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJeep);
export default __webpack_public_path__ + "static/media/jeep.621a23e8bac9c9d80c0884a143799959.svg";
export { ForwardRef as ReactComponent };